import React from "react";

import { Container } from "@mui/material";
import PropTypes from "prop-types";

import stylizeComponent from "styles/stylizeComponent";

const StyledContainer = stylizeComponent(
  Container,
  ["backgroundColor", "padding"],
  ({ theme, backgroundColor, padding }) => ({
    "&.MuiContainer-root": {
      backgroundColor: backgroundColor || theme.palette.customized.widgetBackground,
      height: "auto",
      minHeight: "7rem",
      display: "flow-root",
      padding,
    },
  }),
);

/**
 * Main global container used to embed the whole widget (components and pages)
 */
const WidgetContainer = ({
  maxWidth = "lg",
  fixed = false,
  backgroundColor = null,
  padding = "0rem",
  children,
}) => (
  <StyledContainer
    maxWidth={maxWidth}
    fixed={fixed}
    padding={padding}
    backgroundColor={backgroundColor}
    id="widget-container"
  >
    {children}
  </StyledContainer>
);

WidgetContainer.propTypes = {
  /**
   * The widget wrapped components and pages.
   */
  children: PropTypes.any.isRequired,
  /**
   * The maximum width of the content.
   */
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xs"]),
  /**
   * Whether the container width must be fixed to the previous screen breakpoint value.
   */
  fixed: PropTypes.bool,
  /**
   * The background color of the widget container.
   */
  backgroundColor: PropTypes.string,
  /**
   * The padding of the widget container.
   */
  padding: PropTypes.string,
};

export default WidgetContainer;
